module.exports = __webpack_public_path__ + "img/MoveSVG.fb720cf6.svg";